/**
 * Service Dashboard - Visao Geral configuravel (Bloco VG).
 *
 * Persiste a preferencia singleton do usuario logado (quais widgets,
 * em que ordem, em qual tamanho). O catalogo dos widgets em si vive
 * no frontend em `pages/VisaoGeral/_catalogo.js`.
 *
 * Endpoint:
 *   GET  /api/me/dashboard-preferencia  -> {widgets: [...], atualizado_em}
 *   PUT  /api/me/dashboard-preferencia  body {widgets: [...]}
 *
 * Schema de cada item de `widgets`:
 *   {id: "throughput", posicao?: 0, tamanho?: "S"|"M"|"L"}
 *
 * Sem cargo/permissao na rota: cada usuario le/edita SO a propria.
 */

const URL = "/api/me/dashboard-preferencia";

export function obterPreferenciaDashboard(request) {
  return request(URL);
}

export function salvarPreferenciaDashboard(request, widgets) {
  return request(URL, {
    method: "PUT",
    body: JSON.stringify({ widgets }),
    headers: { "Content-Type": "application/json" },
    // silentError: tratamos erro inline no painel (toast nao serve aqui)
    silentError: true,
  });
}
